import { ICohort, ICourse } from '@/types/course';
import { Chip } from '@mui/material';
import pluralize from 'pluralize';

type CourseDetailStripProps = {
  course: Pick<ICourse, 'level' | 'categories' | 'cohorts'>;
  cohort: ICohort;
};

export function CourseDetailStrip({ course, cohort }: CourseDetailStripProps) {
  const { duration } = cohort;
  const durationLabel = duration
    ? pluralize(duration.type ?? '', duration.quantity ?? 0, true)
    : null;

  return (
    <div className="flex gap-1 flex-wrap">
      {[course.categories?.[0]?.name, course.level, durationLabel]
        .filter(Boolean)
        .map(label => (
          <Chip
            className="rounded-sm capitalize font-medium"
            key={label}
            label={label}
            size="small"
            variant="outlined"
          />
        ))}
    </div>
  );
}
